/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LoadingState/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import LoadingSpinner from 'DesignSystem/LoadingSpinner/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LoadingState({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/LoadingState",
  isSubmitting
  
}) {
let appointmentOverlayIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'appointment_overlay',
})
let dtColorsOverlay400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.overlay.400'
        })
  return (<React.Fragment
>
<fromFlow.When is={appointmentOverlayIsSubmittingData}>
<div
  data-testid="LoadingState.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-1Q2kh9': dtColorsOverlay400}}
 className={`views-block ${styles.Vertical}`}
>
<LoadingSpinner
  viewPath={`${viewPath}/LoadingSpinner`}
 height={40}
 width={40}
 delay={1000}
/>
</div>
</fromFlow.When>
{children}
</React.Fragment>)
}